import Filter from "features/view/components/Filters/Filter";
import FacetGroup from "features/view/components/Facets/FacetGroup";
import Facet from "features/view/components/Facets/Facet";
import { useView } from "features/view/context/ViewContext";

function Facets() {
  const { view } = useView();
  let facets = null;
  if (view && view.facets_metadata) {
    facets = Object.keys(view.facets_metadata).map(
      (key, index) => {
        const facetInfo = view.facets_metadata[key];
        if (!facetInfo) {
          console.warn(`No facet info available for facet ${ key }`);
          return null;
        }

        let results = [];
        view.facets.forEach(facet => {
          const facetFilters = facet[0] && facet[0][key];
          if (!facetFilters) {
            return null;
          }

          let isGrouped = false;
          const filters = facetFilters.map(
            (filter, index) => {
              if (!filter.values) {
                return null;
              }

              if (filter.children) {
                isGrouped = true;
                return (
                  <FacetGroup
                    key={ index }
                    label={ filter.values.value }
                    items={ filter.children[0] }
                    expanded={ index === 0 && facetFilters.length === 1 }
                    hideHeader={ index === 0 && facetFilters.length === 1 }
                  />
                )
              } else {
                return <Facet key={ index }
                              label={ filter.values.value }
                              count={ filter.values.count }
                              url={ filter.url }
                              active={ filter.values.active === "true" }/>;
              }
            }
          );

          results.push(
            <Filter key={ index } title={ facetInfo.label } type={ !isGrouped ? "option-list" : "" }>
              { filters }
            </Filter>
          );
        });
        return results;
      }
    );
  }
  return facets;
}

export default Facets;
